module.exports = __webpack_public_path__ + "static/media/godishen_plan.e35c1a1d.png";